import { render, staticRenderFns } from "./Project2Zh.vue?vue&type=template&id=5a83ad87&scoped=true&"
import script from "./Project2Zh.vue?vue&type=script&lang=js&"
export * from "./Project2Zh.vue?vue&type=script&lang=js&"
import style0 from "./Project2Zh.vue?vue&type=style&index=0&id=5a83ad87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a83ad87",
  null
  
)

export default component.exports